import { createRouter, createWebHistory } from "vue-router";
import { defineAsyncComponent } from "vue";
import { message } from "ant-design-vue";
import store from '../store/index'

//3.0异步组建写法
//const home = () => import("../views/home.vue");
const home = () => import("../views/document.vue");
const list = defineAsyncComponent(() => import("../views/list.vue"));
const submitOrder = defineAsyncComponent(() => import("../views/submitOrder.vue"));
const orderList = defineAsyncComponent(() => import("../views/my/orderList.vue"));
const orderDetail = defineAsyncComponent(() => import("../views/my/orderDetail.vue"));
const orderRefund = defineAsyncComponent(() => import("../views/my/orderRefund.vue"));
const endorsed = defineAsyncComponent(() => import("../views/my/endorsed.vue"));
const amountList = defineAsyncComponent(() => import("../views/my/amountList.vue"));
const billList = defineAsyncComponent(() => import("../views/my/billList.vue"));
const billListDetail = defineAsyncComponent(() => import("../views/my/billListDetail.vue"));

//线下票账单
const offlineBillList = defineAsyncComponent(() => import("../views/my/offlineBillList.vue"));
const offlineBillListDetail = defineAsyncComponent(() => import("../views/my/offlineBillListDetail.vue"));

const rechargeDetail = defineAsyncComponent(() => import("../views/my/rechargeDetail.vue"));
const createRecharge = defineAsyncComponent(() => import("../views/my/createRecharge.vue"));

const my = defineAsyncComponent(() => import("../views/my/index.vue"));
const passenger = defineAsyncComponent(() => import("../views/my/passenger.vue"));
const platform = defineAsyncComponent(() => import("../views/my/platform.vue"));
const document = defineAsyncComponent(() => import("../views/document.vue"));
const payment = defineAsyncComponent(() => import("../views/payment.vue"));
const rob = defineAsyncComponent(() => import("../views/rob.vue"));
const robDetail = defineAsyncComponent(() => import("../views/my/robDetail.vue"));



const login = defineAsyncComponent(() => import("../views/login.vue"));

const routerArr = [
  {
    path: "/",
    name: "home",
    component: home,
    meta: {
      bannerShow: true
    }
  },
  {
    path: "/list",
    name: "list",
    component: list,
    meta: {
      bannerShow: true
    }
  },
  {
    path: "/submitOrder",
    name: "submitOrder",
    component: submitOrder,
    meta: {
      bannerShow: false
    }
  },
  {
    path: "/my",
    name: "my",
    component: my,
    redirect:'/orderList',
    children : [
      {
        path: "/orderList",
        name: "orderList",
        component: orderList,
        meta: {
          bannerShow: false
        }
      },
      {
        path: "/orderDetail",
        name: "orderDetail",
        component: orderDetail,
        meta: {
          bannerShow: false
        }
      },
      {
        path: "/orderRefund",
        name: "orderRefund",
        component: orderRefund,
        meta: {
          bannerShow: false
        }
      },
      {
        path: "/endorsed",
        name: "endorsed",
        component: endorsed,
        meta: {
          bannerShow: false
        }
      },
      {
        path: "/amountList",
        name: "amountList",
        component: amountList,
        meta: {
          bannerShow: false
        }
      },
      {
        path: "/billList",
        name: "billList",
        component: billList,
        meta: {
          bannerShow: false
        }
      },
      {
        path: "/billListDetail",
        name: "billListDetail",
        component: billListDetail,
        meta: {
          bannerShow: false
        }
      },
      {
        path: "/offlineBillList",
        name: "offlineBillList",
        component: offlineBillList,
        meta: {
          bannerShow: false
        }
      },
      {
        path: "/offlineBillListDetail",
        name: "offlineBillListDetail",
        component: offlineBillListDetail,
        meta: {
          bannerShow: false
        }
      },
      {
        path: "/rechargeDetail",
        name: "rechargeDetail",
        component: rechargeDetail,
        meta: {
          bannerShow: false
        }
      },
      {
        path: "/createRecharge",
        name: "createRecharge",
        component: createRecharge,
        meta: {
          bannerShow: false
        }
      },
      {
        path: "/passenger",
        name: "passenger",
        component: passenger,
        meta: {
          bannerShow: false
        }
      },
      {
        path: "/platform",
        name: "platform",
        component: platform,
        meta: {
          bannerShow: false
        }
      },
      {
        path: "/robDetail",
        name: "robDetail",
        component: robDetail,
        meta: {
          bannerShow: false
        }
      }
    ],
    meta: {
      bannerShow: false,
      title : '火车票'
    }
  },

  {
    path: "/login",
    name: "login",
    component: login,
    meta: {
      bannerShow: false
    }
  },
  {
    path: "/document",
    name: "document",
    component: document,
    meta: {
      bannerShow: false
    }
  },
  {
    path: "/payment",
    name: "payment",
    component: payment,
    meta: {
      bannerShow: false
    }
  },
  {
    path: "/rob",
    name: "rob",
    component: rob,
    meta: {
      bannerShow: false
    }
  },

];

let router = createRouter({
  history: createWebHistory('/train_pc/'),
  routes: routerArr
});

const noLoginRouter = [
  'login',
  'home'
]

router.beforeEach((to, from, next) => {
  if(noLoginRouter.indexOf(to.name) > -1){
      //不需要登陆页面
      next()
  }else{
      if(store.state.token){
        next()

      }else{
        sessionStorage.setItem('url',to.name);
        sessionStorage.setItem('urlq',JSON.stringify(to.query));
        next({name: 'login'})
      }
  }
});


router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
});

export { routerArr, router };
